import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { FormSelect } from '../Form'
import { CalendarDaysIcon } from '@heroicons/vue/24/solid'
import type { FormSelectOption, FormSelectValue } from '@/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormMonthPicker',
  props: /*@__PURE__*/_mergeModels({
    placeholder: {},
    isCurrentYear: { type: Boolean, default: false }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel<FormSelectValue>(__props, "modelValue");

const options: FormSelectOption[] = [
    { value: 1, label: "Januari", icon: CalendarDaysIcon },
    { value: 2, label: "Februari", icon: CalendarDaysIcon },
    { value: 3, label: "Maart", icon: CalendarDaysIcon },
    { value: 4, label: "April", icon: CalendarDaysIcon },
    { value: 5, label: "Mei", icon: CalendarDaysIcon },
    { value: 6, label: "Juni", icon: CalendarDaysIcon },
    { value: 7, label: "July", icon: CalendarDaysIcon },
    { value: 8, label: "Augustus", icon: CalendarDaysIcon },
    { value: 9, label: "September", icon: CalendarDaysIcon },
    { value: 10, label: "Oktober", icon: CalendarDaysIcon },
    { value: 11, label: "November", icon: CalendarDaysIcon },
    { value: 12, label: "December", icon: CalendarDaysIcon },
];



const filteredOptions = computed(() => {
  if (!__props.isCurrentYear) return options;

  return options.filter(option => option.value as number <= new Date().getMonth() + 1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FormSelect), {
    placeholder: _ctx.placeholder,
    options: filteredOptions.value,
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
  }, null, 8, ["placeholder", "options", "modelValue"]))
}
}

})